import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { LogIn } from "lucide-react";
import { useCustomerAuth } from "./CustomerAuthContext";

export default function CustomerLogin() {
  const { customer, login } = useCustomerAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (customer) return <Navigate to="/customer" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      nav("/customer", { replace: true });
    } catch (e) {
      setError(String(e.message || "Login failed"));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-sky-50 flex items-center justify-center p-4" data-testid="customer-login-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl border border-slate-100 p-8">
        <div className="text-center mb-6">
          <div className="font-black text-2xl text-[#0a2a5e] tracking-tight">BAISHALII</div>
          <div className="text-xs uppercase tracking-widest text-slate-400 mt-1">Customer Portal</div>
        </div>
        <h1 className="text-xl font-bold text-slate-800 mb-1">Sign in</h1>
        <p className="text-sm text-slate-500 mb-6">Access your invoices, delivery notes and account statement.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-xs font-semibold text-slate-500 mb-1">Email</label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="customer-login-email" autoFocus />
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-500 mb-1">Password</label>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="customer-login-password" />
          </div>
          {error && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="customer-login-error">{error}</div>}
          <Button type="submit" disabled={loading} data-testid="customer-login-btn" className="w-full bg-[#0a2a5e] hover:bg-[#0a2a5e]/90 text-white rounded-full py-2.5">
            <LogIn className="h-4 w-4 mr-2" /> {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <p className="text-xs text-slate-400 text-center mt-6">Trouble signing in? Contact your BAISHALII sales manager.</p>
      </div>
    </div>
  );
}
